export const locale = {
    lang: 'pl',
    data: {
        "All": "Wszystkie",
        "Products": "Produkty",
        "Vouchers": "Karnety",
        "Active discounts": "Aktywne rabaty",
        "Open bills": "Otwarte rachunki",
    }
};
